(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fd-custom-enquiry"] && !Shopify.designMode) return;
  try {
    function initCustomFigureEnquiries() {
    document.querySelectorAll('[data-custom-enquiry]').forEach((dialog) => {
      if (dialog.dataset.enquiryReady || typeof dialog.showModal !== 'function') return;
      dialog.dataset.enquiryReady = 'true';
      const trigger = document.querySelector('[data-enquiry-open="' + CSS.escape(dialog.id) + '"]');
      if (trigger) trigger.addEventListener('click', (event) => {
        event.preventDefault();
        dialog.showModal();
      });
      dialog.querySelector('[data-enquiry-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      const success = dialog.querySelector('[data-enquiry-success]');
      const error = dialog.querySelector('[data-enquiry-error]');
      const submittedHere = window.location.hash === '#' + dialog.querySelector('form').id;
      if (success && submittedHere) {
        dialog.close();
        const confirmation = success.cloneNode(true);
        confirmation.classList.add('fdg-enquiry-confirmation');
        dialog.before(confirmation);
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('contact_posted');
        cleanUrl.hash = '';
        window.history.replaceState(window.history.state, '', cleanUrl.pathname + cleanUrl.search);
      } else if (error && submittedHere) dialog.showModal();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCustomFigureEnquiries);
  else initCustomFigureEnquiries();
  document.addEventListener('shopify:section:load', initCustomFigureEnquiries);
  } catch(e) { console.error(e); }
})();

})();
